import React, { Component } from 'react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import { withNavigation } from 'src/ui/hoc';

import { Columns, Column, MuiTitle } from 'src/ui/mui-ui-kit';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';
import {
  setBreadcrumbs,
  reduceServerErrors,
  ConfirmDeletionModal,
  UiToastAdapter,
} from 'src/ui';
import { getUser } from 'src/user';
import {
  getAccount,
  fetchAccount,
  fetchTasks,
  deleteAccountTask,
} from 'src/account';
import { ScheduledTasksTable } from '../components';

const ScheduledTasksListPage = ({
  setBreadcrumbs,
  fetchTasks,
  user,
  deleteAccountTask,
  history,
  tasks,
  account,
}) => {
  const [loading, setLoading] = React.useState(true);
  const [deletingTask, setDeletingTask] = React.useState(null);

  React.useEffect(() => {
    (async () => {
      const id = user.financialInstitutionId || user.fiSelectedAccountId;

      setBreadcrumbs([{ label: 'Scheduled Tasks', href: '/scheduled-tasks' }]);

      await fetchTasks(id);

      setLoading(false);
    })();
  }, []);

  const onDeleteTask = task => {
    setDeletingTask(task);
  };

  const onCancelDeleteTask = () => {
    setDeletingTask(null);
  };

  const onConfirmDeleteTask = async () => {
    const fiId = user.financialInstitutionId || user.fiSelectedAccountId;

    setLoading(true);
    onCancelDeleteTask();

    await deleteAccountTask({
      fi: fiId,
      taskId: deletingTask.taskId,
    });

    setLoading(false);

    if (!tasks) {
      return reduceServerErrors(tasks);
    }

    if (fiId) {
      await Promise.all([fetchTasks(fiId)]);
    }

    toast(UiToastAdapter('Task deleted successfully!', 'success'));
    history.push('scheduled-tasks');
    return undefined;
  };

  return (
    <>
      <Columns isMultiline>
        <Column isSize="1/2">
          <MuiTitle isSize="4" hasTextColor="info" tag="h2">
            Tasks
          </MuiTitle>
        </Column>
        <Column isSize="1/2">
          <NavLink
            className="button is-gradient-bright is-long is-pulled-right"
            to="/scheduled-tasks/add"
          >
            <span className="icon is-left">
              <FontAwesomeIcon icon={['fal', 'plus']} />
            </span>
            <span>Add Task</span>
          </NavLink>
        </Column>
        <Column>
          <ScheduledTasksTable
            loading={loading}
            tasks={account.tasks || []}
            onDeleteTask={onDeleteTask}
          />
        </Column>
      </Columns>
      {deletingTask && (
        <ConfirmDeletionModal
          isActive={!!deletingTask}
          onClickCancel={onCancelDeleteTask}
          onClickConfirm={onConfirmDeleteTask}
          title={`Scheduled Task for ${(deletingTask || {}).taskEmail ||
            deletingTask ||
            {}}`}
        />
      )}
    </>
  );
};

ScheduledTasksListPage.propTypes = {
  history: propTypes.object.isRequired,
  setBreadcrumbs: propTypes.func.isRequired,
  fetchTasks: propTypes.func.isRequired,
  deleteAccountTask: propTypes.func.isRequired,
  tasks: propTypes.object.isRequired,
  user: propTypes.object.isRequired,
  account: propTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    account: getAccount(state),
    tasks: fetchTasks(state),
    user: getUser(state),
  };
}

const connectedScheduledTasksListPage = connect(mapStateToProps, {
  setBreadcrumbs,
  fetchAccount,
  fetchTasks,
  deleteAccountTask,
})(withNavigation(ScheduledTasksListPage));

export { connectedScheduledTasksListPage as ScheduledTasksListPage };
